import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  _Any: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export enum AWSRegions {
  EU_CENTRAL_1 = 'EU_CENTRAL_1',
  EU_NORTH_1 = 'EU_NORTH_1',
  EU_WEST_1 = 'EU_WEST_1',
  EU_WEST_2 = 'EU_WEST_2',
  EU_WEST_3 = 'EU_WEST_3',
  US_EAST_1 = 'US_EAST_1',
  US_EAST_2 = 'US_EAST_2',
  US_WEST_1 = 'US_WEST_1',
  US_WEST_2 = 'US_WEST_2'
}

export enum AuthMethod {
  AUTH_CODE = 'AUTH_CODE',
  CREDENTIALS = 'CREDENTIALS',
  MIDWAY = 'MIDWAY',
  OKTA = 'OKTA'
}

export type Consent = {
  __typename?: 'Consent';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Float']['output']>;
};

export type ConsentInput = {
  accepted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  region: AWSRegions;
  username: Scalars['ID']['input'];
};

export type ExtendedGetUsersResponse = {
  __typename?: 'ExtendedGetUsersResponse';
  lastEvaluatedKey: Maybe<LastEvaluatedKeyType>;
  users: Array<ExtendedUserResponse>;
};

export type ExtendedUpdateUserInput = {
  attributes: InputMaybe<Scalars['JSON']['input']>;
  authMethod: InputMaybe<AuthMethod>;
  email: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  groups: InputMaybe<Array<Scalars['String']['input']>>;
  lastLogin: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  roles: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExtendedUserInput = {
  attributes: InputMaybe<Scalars['JSON']['input']>;
  authMethod: AuthMethod;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groups: Array<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
  siteUrl: InputMaybe<Scalars['String']['input']>;
  suppressNotification: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExtendedUserResponse = {
  __typename?: 'ExtendedUserResponse';
  attributes: Maybe<Scalars['JSON']['output']>;
  authMethod: AuthMethod;
  consents: Maybe<Array<Consent>>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups: Maybe<Array<Scalars['String']['output']>>;
  lastLogin: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  roles: Maybe<Array<Scalars['String']['output']>>;
  status: UserStatus;
  username: Scalars['ID']['output'];
};

export type ExtendedUserSearchResponse = {
  __typename?: 'ExtendedUserSearchResponse';
  nextCursorToken: Scalars['String']['output'];
  users: Array<ExtendedUserResponse>;
};

export type GetUsersFilterInput = {
  groups: Array<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type GetUsersInput = {
  filter: GetUsersFilterInput;
  page: PaginationInput;
  region: AWSRegions;
};

export type LastEvaluatedKeyInput = {
  username: Scalars['String']['input'];
};

export type LastEvaluatedKeyType = {
  __typename?: 'LastEvaluatedKeyType';
  username: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createUser: User;
  putConsent: Consent;
  updateUser: ExtendedUserResponse;
};


export type MutationcreateUserArgs = {
  region: AWSRegions;
  user: ExtendedUserInput;
};


export type MutationputConsentArgs = {
  consentInput: ConsentInput;
};


export type MutationupdateUserArgs = {
  input: ExtendedUpdateUserInput;
  region: AWSRegions;
  username: Scalars['String']['input'];
};

export type PaginationInput = {
  lastEvaluatedKey: InputMaybe<LastEvaluatedKeyInput>;
  limit: Scalars['Float']['input'];
};

export type Query = {
  __typename?: 'Query';
  _health: Scalars['String']['output'];
  _service: _Service;
  getAllGroups: Array<Scalars['String']['output']>;
  getAllRoles: Array<Scalars['String']['output']>;
  getUser: ExtendedUserResponse;
  getUsers: ExtendedGetUsersResponse;
  searchUsers: ExtendedUserSearchResponse;
};


export type QuerygetUserArgs = {
  region: AWSRegions;
  username: Scalars['ID']['input'];
};


export type QuerygetUsersArgs = {
  params: GetUsersInput;
};


export type QuerysearchUsersArgs = {
  userSearch: UserSearchInput;
};

export type User = {
  __typename?: 'User';
  authMethod: AuthMethod;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  status: UserStatus;
  username: Scalars['ID']['output'];
};

export enum UserSearchFilterKeys {
  email = 'email',
  firstName = 'firstName',
  lastName = 'lastName'
}

export type UserSearchInput = {
  filter: UserSearchInputFilter;
  page: UserSearchInputPage;
  region: AWSRegions;
};

export type UserSearchInputFilter = {
  key: UserSearchFilterKeys;
  value: Scalars['String']['input'];
};

export type UserSearchInputPage = {
  cursorToken: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Float']['input'];
};

export enum UserStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  PENDING = 'PENDING'
}

export type _Service = {
  __typename?: '_Service';
  sdl: Maybe<Scalars['String']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AWSRegions: AWSRegions;
  AuthMethod: AuthMethod;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Consent: ResolverTypeWrapper<Consent>;
  ConsentInput: ConsentInput;
  ExtendedGetUsersResponse: ResolverTypeWrapper<ExtendedGetUsersResponse>;
  ExtendedUpdateUserInput: ExtendedUpdateUserInput;
  ExtendedUserInput: ExtendedUserInput;
  ExtendedUserResponse: ResolverTypeWrapper<ExtendedUserResponse>;
  ExtendedUserSearchResponse: ResolverTypeWrapper<ExtendedUserSearchResponse>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GetUsersFilterInput: GetUsersFilterInput;
  GetUsersInput: GetUsersInput;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  LastEvaluatedKeyInput: LastEvaluatedKeyInput;
  LastEvaluatedKeyType: ResolverTypeWrapper<LastEvaluatedKeyType>;
  Mutation: ResolverTypeWrapper<{}>;
  PaginationInput: PaginationInput;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  User: ResolverTypeWrapper<User>;
  UserSearchFilterKeys: UserSearchFilterKeys;
  UserSearchInput: UserSearchInput;
  UserSearchInputFilter: UserSearchInputFilter;
  UserSearchInputPage: UserSearchInputPage;
  UserStatus: UserStatus;
  _Any: ResolverTypeWrapper<Scalars['_Any']['output']>;
  _FieldSet: ResolverTypeWrapper<Scalars['_FieldSet']['output']>;
  _Service: ResolverTypeWrapper<_Service>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean']['output'];
  Consent: Consent;
  ConsentInput: ConsentInput;
  ExtendedGetUsersResponse: ExtendedGetUsersResponse;
  ExtendedUpdateUserInput: ExtendedUpdateUserInput;
  ExtendedUserInput: ExtendedUserInput;
  ExtendedUserResponse: ExtendedUserResponse;
  ExtendedUserSearchResponse: ExtendedUserSearchResponse;
  Float: Scalars['Float']['output'];
  GetUsersFilterInput: GetUsersFilterInput;
  GetUsersInput: GetUsersInput;
  ID: Scalars['ID']['output'];
  JSON: Scalars['JSON']['output'];
  LastEvaluatedKeyInput: LastEvaluatedKeyInput;
  LastEvaluatedKeyType: LastEvaluatedKeyType;
  Mutation: {};
  PaginationInput: PaginationInput;
  Query: {};
  String: Scalars['String']['output'];
  User: User;
  UserSearchInput: UserSearchInput;
  UserSearchInputFilter: UserSearchInputFilter;
  UserSearchInputPage: UserSearchInputPage;
  _Any: Scalars['_Any']['output'];
  _FieldSet: Scalars['_FieldSet']['output'];
  _Service: _Service;
};

export type extendsDirectiveArgs = { };

export type extendsDirectiveResolver<Result, Parent, ContextType = any, Args = extendsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type externalDirectiveArgs = {
  reason: Maybe<Scalars['String']['input']>;
};

export type externalDirectiveResolver<Result, Parent, ContextType = any, Args = externalDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type keyDirectiveArgs = {
  fields: Scalars['_FieldSet']['input'];
  resolvable?: Maybe<Scalars['Boolean']['input']>;
};

export type keyDirectiveResolver<Result, Parent, ContextType = any, Args = keyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type providesDirectiveArgs = {
  fields: Scalars['_FieldSet']['input'];
};

export type providesDirectiveResolver<Result, Parent, ContextType = any, Args = providesDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type requiresDirectiveArgs = {
  fields: Scalars['_FieldSet']['input'];
};

export type requiresDirectiveResolver<Result, Parent, ContextType = any, Args = requiresDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type tagDirectiveArgs = {
  name: Scalars['String']['input'];
};

export type tagDirectiveResolver<Result, Parent, ContextType = any, Args = tagDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Consent'] = ResolversParentTypes['Consent']> = {
  accepted: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtendedGetUsersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtendedGetUsersResponse'] = ResolversParentTypes['ExtendedGetUsersResponse']> = {
  lastEvaluatedKey: Resolver<Maybe<ResolversTypes['LastEvaluatedKeyType']>, ParentType, ContextType>;
  users: Resolver<Array<ResolversTypes['ExtendedUserResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtendedUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtendedUserResponse'] = ResolversParentTypes['ExtendedUserResponse']> = {
  attributes: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  authMethod: Resolver<ResolversTypes['AuthMethod'], ParentType, ContextType>;
  consents: Resolver<Maybe<Array<ResolversTypes['Consent']>>, ParentType, ContextType>;
  email: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groups: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  lastLogin: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  status: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  username: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtendedUserSearchResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtendedUserSearchResponse'] = ResolversParentTypes['ExtendedUserSearchResponse']> = {
  nextCursorToken: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  users: Resolver<Array<ResolversTypes['ExtendedUserResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JSONScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LastEvaluatedKeyTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastEvaluatedKeyType'] = ResolversParentTypes['LastEvaluatedKeyType']> = {
  username: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createUser: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationcreateUserArgs, 'region' | 'user'>>;
  putConsent: Resolver<ResolversTypes['Consent'], ParentType, ContextType, RequireFields<MutationputConsentArgs, 'consentInput'>>;
  updateUser: Resolver<ResolversTypes['ExtendedUserResponse'], ParentType, ContextType, RequireFields<MutationupdateUserArgs, 'input' | 'region' | 'username'>>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _health: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _service: Resolver<ResolversTypes['_Service'], ParentType, ContextType>;
  getAllGroups: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  getAllRoles: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  getUser: Resolver<ResolversTypes['ExtendedUserResponse'], ParentType, ContextType, RequireFields<QuerygetUserArgs, 'region' | 'username'>>;
  getUsers: Resolver<ResolversTypes['ExtendedGetUsersResponse'], ParentType, ContextType, RequireFields<QuerygetUsersArgs, 'params'>>;
  searchUsers: Resolver<ResolversTypes['ExtendedUserSearchResponse'], ParentType, ContextType, RequireFields<QuerysearchUsersArgs, 'userSearch'>>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  authMethod: Resolver<ResolversTypes['AuthMethod'], ParentType, ContextType>;
  email: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  username: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface _AnyScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['_Any'], any> {
  name: '_Any';
}

export interface _FieldSetScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['_FieldSet'], any> {
  name: '_FieldSet';
}

export type _ServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['_Service'] = ResolversParentTypes['_Service']> = {
  sdl: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Consent: ConsentResolvers<ContextType>;
  ExtendedGetUsersResponse: ExtendedGetUsersResponseResolvers<ContextType>;
  ExtendedUserResponse: ExtendedUserResponseResolvers<ContextType>;
  ExtendedUserSearchResponse: ExtendedUserSearchResponseResolvers<ContextType>;
  JSON: GraphQLScalarType;
  LastEvaluatedKeyType: LastEvaluatedKeyTypeResolvers<ContextType>;
  Mutation: MutationResolvers<ContextType>;
  Query: QueryResolvers<ContextType>;
  User: UserResolvers<ContextType>;
  _Any: GraphQLScalarType;
  _FieldSet: GraphQLScalarType;
  _Service: _ServiceResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  extends: extendsDirectiveResolver<any, any, ContextType>;
  external: externalDirectiveResolver<any, any, ContextType>;
  key: keyDirectiveResolver<any, any, ContextType>;
  provides: providesDirectiveResolver<any, any, ContextType>;
  requires: requiresDirectiveResolver<any, any, ContextType>;
  tag: tagDirectiveResolver<any, any, ContextType>;
};
